import { Grid, Skeleton, Stack } from '@mui/material'
import React from 'react'

function BillingSkeleton() {
    return (
        <Grid container spacing={2}>
            <Grid item md={3} xs={12}>
                <Stack direction={'column'} spacing={2}>
                    <Skeleton variant='rectangular' sx={{ borderRadius: 1 }} width={'100%'} height={150}></Skeleton>
                    <Skeleton variant='rectangular' sx={{ borderRadius: 1 }} width={'100%'} height={150}></Skeleton>
                    <Skeleton variant='rectangular' sx={{ borderRadius: 1 }} width={'100%'} height={150}></Skeleton>
                </Stack>
            </Grid>
            <Grid item md={9} xs={12}>
            <Stack direction={'column'} spacing={2}>
                    <Skeleton variant='rectangular' sx={{ borderRadius: 1 }} width={'100%'} height={150}></Skeleton>
                    <Skeleton variant='rectangular' sx={{ borderRadius: 1 }} width={'100%'} height={400}></Skeleton>
                    <Skeleton variant='rectangular' sx={{ borderRadius: 1 }} width={'100%'} height={150}></Skeleton>
                </Stack>
            </Grid>
        </Grid>
    )
}

export default BillingSkeleton